import { render, staticRenderFns } from "./CompanyCustomLogo.vue?vue&type=template&id=1766dba1"
import script from "./CompanyCustomLogo.vue?vue&type=script&lang=js"
export * from "./CompanyCustomLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports